import React from "react";
import styles from "./styles.module.scss";

export const Card = ({ item }) => {
  const { label, value, Icon, info } = item;
  return (
    <div className={styles.card}>
      <div className={styles.cardInfo}>
        <div className={styles.label}>{label}</div>

        <div className={styles.value}>{value}</div>
        <div className={styles.info}>
          <div className={styles.infoCircle}>i</div>
          <div>{info}</div>
        </div>
      </div>
      <div className={styles.iconContainer}>
        <Icon />
      </div>
    </div>
  );
};
